// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"acfd1071","408":"49125c37"}[chunkId] + ".chunk.js";
};